import * as React from 'react'
import { ReactElement, useContext, useEffect, useState } from 'react'

import {AppContext} from "../../../Context/AppContext"

import {postier} from "./Postier"

export function Create({ setPagina, eventsTypes }): ReactElement {

    const { token, client, site, setErrors } = useContext(AppContext)

    const [fields, setFields] = useState({ id_event: '0', type: 1, description: '', title: '', fromDate: '', toDate: ''});

    const [sousEvent,setSousEvent] = useState([])
    const [filteredList, setFilteredList] = useState([])

    useEffect(() => {
        postier.getSousEvents(token, client.split(":")[3], setSousEvent, setErrors)
    }, [])

    useEffect(()  => {
        let sousEventsCopy = [...sousEvent];
        sousEventsCopy = sousEventsCopy.filter((se, _) => {
            return se.id_event_type === fields.type
        })
        setFilteredList(sousEventsCopy)

        const fieldsCopy = { ...fields }
        fieldsCopy.id_event = sousEventsCopy[0]?.IDEvent
        setFields(fieldsCopy)
    }, [sousEvent])

    const submit = () => {
        if (validate()) {
            const event = {
                code: client.split(':')[0],
                id_site: site.split(':')[0],
                id_event : parseInt(fields.id_event),
                Title: fields.title,
                Type: fields.type,
                Description: fields.description,
                FromDate: fields.fromDate.replace('T', ' ') + ':00',
                ToDate: fields.toDate.replace('T', ' ') + ':00',
                apiId: localStorage.getItem('apiId'),
                database: client.split(':')[3]
            }

            postier.createEvent(token, event, setPagina, setErrors)
        }
    }

    const validate = () => {
        for (var evt in fields) {
            if (fields[evt] === '') {
                setErrors((errors: string[]) => [...errors, `${evt} ne peut pas être vide`])
                return false;
            }
        }

        if (fields.fromDate > fields.toDate) {
            setErrors((errors: string[]) => [...errors, 'La date de début ne peut pas être supérieure à la date de fin'])
            return false;
        }

        return true;
    }

    const handleChange = (field: string, e) => {
        const fieldsCopy = { ...fields };
        fieldsCopy[field] = e.target.value;
        setFields(fieldsCopy);
    };

    const handleEventTypeChange = (e) => {
        const fieldsCopy = { ...fields };
        fieldsCopy.type = parseInt(e.target.value);
        let sousEventsCopy = [...sousEvent];
        sousEventsCopy = sousEventsCopy.filter((se, _) => {
            return se.id_event_type === fieldsCopy.type
        })
        fieldsCopy.id_event = sousEventsCopy[0].IDEvent
        setFilteredList(sousEventsCopy)
        setFields(fieldsCopy);
    };

    return (
        <div className="form">
            <h2>Création événement</h2>

                <label>Code Client</label>
                <label className="label"> { client.split(":")[0] }</label>

                <label>Catégorie d'évènement</label>

                <select className="label" onChange={handleEventTypeChange} >
                    {eventsTypes?.map((et, index: number) => <option key={index} value={et.id_event_type}>{et.label}</option>)}
                </select>

                <label>Sous-catégorie d'évènement</label>

                <select className="label" onChange={e => handleChange('id_event', e)} >
                    {filteredList?.map((s,index) => <option key={index} value={s.IDEvent}>{s.Name}</option>)}
                </select>


                <label>Titre </label>
                <input className="label" onChange={e => handleChange('title', e)} />


                <label>Description </label>
                <textarea className="label" onChange={e => handleChange('description', e)} />


                <label>Date de début </label>
                <input type="datetime-local" className="label" onChange={e => handleChange('fromDate', e)} />


                <label>Date de fin </label>
                <input type="datetime-local" className="label" onChange={e => handleChange('toDate', e)} />

                {eventsTypes.length > 0 && sousEvent.length > 0 && <button onClick={submit} >Enregistrer</button>}
        </div>
    )
}
